const initialState = {
    isShow: false,
    active: []
};

export default function PreloaderReducer(state = initialState, action) {
    let {type, payload} = action;

    if (payload && payload.showPreloader && payload.showPreloader === true) {
        if (state.isShow === false) {
            state.isShow = true;
        }

        state.active.push(type);

        return {...state};
    }

    let regex = /(_SUCCESS|_FAILURE)$/;

    if (state.isShow && type.search(regex) >= 0) {
        let originalAction = type.replace(regex, '');

        let index = state.active.indexOf(originalAction);

        if (index >= 0) state.active.splice(index, 1);

        if (state.active.length === 0) state.isShow = false;

        return {...state};
    }

    return state;
}